// Shared non-component exports; keep component modules valid Fast Refresh boundaries.

export type MetricId =
  // TeamsDashboardView KPI tiles + agent breakdown columns
  | "registered"
  | "viable"
  | "viable_pct"
  | "quality"
  | "positive_sentiment"
  | "negative_sentiment"
  // Agent profile / agents view
  | "calls_assessed"
  | "avg_duration"
  | "quality_call_pct"
  | "positive_pct"
  | "negative_pct"
  | "too_fast"
  // Measure / assessment surfaces
  | "detection_rate"
  | "coverage"
  | "avg_score"
  | "calls"
  | "prior_period"
  | "team_average"
  | "current_rate"
  | "prior_rate"
  | "delta_pp"
  | "label_distribution";

export const METRIC_TOOLTIPS: Record<MetricId, string> = {
  registered:
    "Every call made or received in this period — the top of the funnel before any filtering.",
  viable:
    "Calls that met the minimum duration to be worth analysing (i.e. weren't immediately abandoned).",
  viable_pct: "Share of registered calls that were viable.",
  quality:
    "Viable calls that connected to someone outside the organisation, had multiple voices detected, and were classified as business-related.",
  positive_sentiment:
    "Calls where the customer said something indicating they were pleased.",
  negative_sentiment:
    "Calls where the customer said something indicating they were frustrated or dissatisfied.",
  calls_assessed:
    "Number of this agent's calls that have been assessed by the AI grading pipeline.",
  avg_duration:
    "Average wall-clock length of analysed calls (mm:ss).",
  quality_call_pct:
    "Share of an agent's analysed calls that qualified as quality calls.",
  positive_pct:
    "Share of an agent's analysed calls flagged as positive sentiment.",
  negative_pct:
    "Share of an agent's analysed calls flagged as negative sentiment.",
  too_fast:
    "Calls that ended faster than the configured minimum useful length — usually hang-ups or wrong numbers.",
  detection_rate:
    "Share of in-scope calls where the grader marked this label as detected, shown as a percentage.",
  coverage:
    "Share of in-scope calls that were actually evaluated against this measure.",
  avg_score:
    "Mean grader score across in-scope calls for this measure (0–1 scale).",
  calls: "Number of calls the percentage on this row was computed from.",
  prior_period:
    "Detection rate for this label during the previous comparable period — the tick mark on the bar.",
  team_average:
    "Detection rate for this label averaged across every agent on the team in the same period.",
  current_rate: "Detection rate in the currently selected period.",
  prior_rate:
    "Detection rate in the previous comparable period (e.g. last week if Weekly is selected).",
  delta_pp:
    "Change in detection rate vs the prior period, in percentage points (pts).",
  label_distribution:
    "Share of detected labels within the focused assessment, by call volume.",
};
